import { useMobile } from "@with-nx/hooks-n-helpers";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import {
  CatalogLayout,
  ReusableDownloadCallToAction,
  ReusablePreSlantedContainer,
} from "@with-nx/simple-ui/organisms";
export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
export default function Page({ resolvedUrl }) {
  const mobile = useMobile();

  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Download Stage Player"
      resolvedUrl={resolvedUrl}
    >
      <ReusablePreSlantedContainer>
        <></>
      </ReusablePreSlantedContainer>
      <ReusableSection bottom={0}>
        <ReusableDownloadCallToAction />
      </ReusableSection>
    </CatalogLayout>
  );
}
